import { render, staticRenderFns } from "./ImageButtonAdd.vue?vue&type=template&id=e4f142dc&scoped=true&"
import script from "./ImageButtonAdd.vue?vue&type=script&lang=js&"
export * from "./ImageButtonAdd.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/sass/style_custom.scss?vue&type=style&index=0&id=e4f142dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f142dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4f142dc')) {
      api.createRecord('e4f142dc', component.options)
    } else {
      api.reload('e4f142dc', component.options)
    }
    module.hot.accept("./ImageButtonAdd.vue?vue&type=template&id=e4f142dc&scoped=true&", function () {
      api.rerender('e4f142dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Forms/Buttons/ImageButtonAdd.vue"
export default component.exports